import React, { FC } from 'react';
import useClassNames from 'helpers/hooks/useClassNames';

export interface BadgeProps {
  discountPercentage: number;
  className?: string;
}

const DiscountBadge: FC<BadgeProps> = ({ discountPercentage, className }) => {
  const badgeClassNames = useClassNames([
    'mb-8 flex h-25 w-70 items-center justify-center rounded bg-emerald-700 text-12 uppercase text-neutral-100',
    className,
  ]);
  return <span className={badgeClassNames}>{Math.round(discountPercentage)}% off</span>;
};

export default DiscountBadge;
